/* istanbul ignore file */ /* plugin extension code */
import type { LDUser } from 'launchdarkly-js-client-sdk';
import { initialize } from 'launchdarkly-js-client-sdk';
import { logger as LOG } from '@sg/garnish';
import '@expo/browser-polyfill';

import { getEnvVars } from '../../../utils';

// ────────────────────────────────────────────────────────────────────────────────
// LOG.enable('LAUNCHDARKLY');
const logger = LOG.extend('LAUNCHDARKLY');
// ────────────────────────────────────────────────────────────────────────────────

const { LAUNCHDARKLY_CLIENT_ID } = getEnvVars();

export const initLaunchDarkly = async (userInfo?: LDUser) => {
  if (!LAUNCHDARKLY_CLIENT_ID) {
    logger.warn('LAUNCHDARKLY_CLIENT_ID is missing');

    return;
  }

  locationHashPolyfill();

  const client = userInfo
    ? initialize(LAUNCHDARKLY_CLIENT_ID, userInfo)
    : initialize(LAUNCHDARKLY_CLIENT_ID, { anonymous: true });

  await client.waitForInitialization();

  logger.debug('LaunchDarkly client initialized');

  return client;
};

// ────────────────────────────────────────────────────────────────────────────────

/**
 * Small polyfill for adding 'hash' property to window.location.
 *
 * location.hash is undefined in case of native platforms,
 * which causes launch darkly client to throw an error.
 */
function locationHashPolyfill() {
  if (typeof window.location.hash === 'undefined') {
    // eslint-disable-next-line functional/immutable-data
    window.location.hash = '';
  }
}
